import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useProfile } from "@/contexts/ProfileContext";
import { useI18n } from "@/contexts/LanguageContext";

const ALLOW_WITHOUT_PROFILE = ["/app/onboarding", "/app/profile", "/app/settings", "/app/membership"];

export default function RequireCompletedProfile({ children }) {
  const { completed, loading } = useProfile();
  const location = useLocation();
  const { t } = useI18n();

  if (completed === null || loading) {
    return (
      <div className="text-sm" style={{ color: "hsl(var(--nvl-ink-soft))" }} data-testid="profile-loading">
        {t("common.loading")}
      </div>
    );
  }

  if (!completed && !ALLOW_WITHOUT_PROFILE.some((p) => location.pathname.startsWith(p))) {
    return <Navigate to="/app/onboarding" replace />;
  }

  return children;
}
